import { appStore } from "../../state/store";
export class OrganizationAnalysis {
    render() {
        const { culturalDrift, strategicAlignment } = appStore.getState().premiumState.multiScalarAnalyticalRepresentations;
        const culturalDriftChart = `
            <div class="mermaid">
            %%{init: {'theme':'dark'}}%%
            xychart-beta
                title "Cultural Drift: Givers vs. Blockers (Q3)"
                x-axis [${culturalDrift.weeks.map(w => `"${w}"`).join(',')}]
                y-axis "Team Headcount"
                line "Givers" [${culturalDrift.distribution.givers.join(',')}]
                line "Blockers" [${culturalDrift.distribution.blockers.join(',')}]
            </div>
        `;
        const alignmentChart = `
            <div class="mermaid">
            pie
                ${strategicAlignment.distribution.map(d => `"${d.priority}": ${d.effortPercentage}`).join('\n')}
            </div>
        `;
        return `
            <div class="analytics-stratum">
                 <div class="governing-principle">
                    <h4>Governing Principle: Systemic Health Diagnosis & Vision-to-Action Traceability</h4>
                    <p>Provides a "God-view" of the organization, enabling leadership to diagnose cultural health, measure strategic alignment, and make high-quality, de-biased decisions.</p>
                </div>

                <div class="chart-grid">
                    <div class="chart-container">
                        <h3>Strategic Alignment Scorecard</h3>
                        <p>Organizational Effort vs. Strategic Priorities</p>
                        ${alignmentChart}
                        <div class="system-insight">
                            <h4>System Insight</h4>
                            <p>${strategicAlignment.insight}</p>
                        </div>
                    </div>
                    <div class="chart-container">
                        <h3>Cultural Health (Trend Analysis)</h3>
                        ${culturalDriftChart}
                        <div class="system-insight">
                            <h4>System Insight</h4>
                            <p>${culturalDrift.insight}</p>
                        </div>
                    </div>
                </div>
                <hr/>
                <div class="executive-summary">
                    <h3>Synthesized Executive Action</h3>
                    <p><strong>Recommendation:</strong> Initiate a Q4 planning review for the teams over-indexed on 'Financial Freedom' projects to re-align their backlog with the 'Leave a Legacy' strategic pillar. Leverage the rising 'Giver' trend by assigning mentors to this process.</p>
                </div>
            </div>
        `;
    }
    attachEventListeners() {
        if (typeof window.mermaid !== 'undefined') {
            window.mermaid.run({ nodes: document.querySelectorAll('.mermaid') });
        }
    }
}
